import { createContext, useContext } from 'react';

import { MessageMedium } from 'constants/messageMediums';
import { FrequencyManagementContext } from 'modules/frequencyManagement/types';

import {
  DataExportOptimizationType,
  DataExportStatus,
  FrequencyMode,
  SupportedMediums,
} from 'modules/frequencyManagement/lib/types';

import { noop } from 'utils/noop';

export const defaultExportData = [
  {
    optimization_id: 0,
    status: 'Finished' as DataExportStatus,
    optimization_type: 'Channel' as DataExportOptimizationType,
    channel: MessageMedium.Email as SupportedMediums,
    message_type: null,
    message_type_id: null,
    min_allowed: 0,
    max_allowed: 0,
    interval_days: 0,
    start_date: '',
    end_date: '',
    optimal_cap: null,
    user_count: null,
    engagement_rate: null,
    unsubscribe_rate: null,
  },
];

export const defaultContext: FrequencyManagementContext = {
  frequencyManagementData: {
    [MessageMedium.Email]: {
      isConfiguredForSending: true,
      settings: {
        mode: FrequencyMode.Off,
        period: null,
        maxAllowed: null,
        minAllowed: null,
        frequencyOptimizationDetails: null,
        frequencyOptimizationDetailsUpdatedAt: null,
      },
      messageTypes: [],
    },
    [MessageMedium.SMS]: {
      isConfiguredForSending: true,
      settings: {
        mode: FrequencyMode.Off,
        period: null,
        maxAllowed: null,
        minAllowed: null,
        frequencyOptimizationDetails: null,
        frequencyOptimizationDetailsUpdatedAt: null,
      },
      messageTypes: [],
    },
    [MessageMedium.Push]: {
      isConfiguredForSending: true,
      settings: {
        mode: FrequencyMode.Off,
        period: null,
        maxAllowed: null,
        minAllowed: null,
        frequencyOptimizationDetails: null,
        frequencyOptimizationDetailsUpdatedAt: null,
      },
      messageTypes: [],
    },
  },
  getOptimizeDetailsMessageMedium: () => ({
    histogramData: {
      histogram_data_points: [],
      csv_export_data: defaultExportData,
    },
    lastUpdated: '',
    areResultsReady: false,
    hasSavedData: false,
  }),
  getOptimizeDetailsMessageType: () => ({
    histogramData: {
      histogram_data_points: [],
      csv_export_data: defaultExportData,
    },
    lastUpdated: '',
    areResultsReady: false,
    hasSavedData: false,
  }),
  getOptimizeModeCountByMedium: () => 0,
  getOptimizeCSVData: () => ({ hasCSVData: true, csvData: [{}] }),
  trigger: noop,
  fetch: noop,
  isError: false,
  isLoading: false,
};

export const CoreContext = createContext<FrequencyManagementContext>(defaultContext);

export const useCoreContext = () => useContext(CoreContext);
